/** Scroll after React has painted the updated DOM (e.g. new table row). */
export function scrollIntoViewAfterPaint(
  elOrGetter: HTMLElement | null | undefined | (() => HTMLElement | null | undefined),
  options: ScrollIntoViewOptions = { block: 'center', behavior: 'smooth' }
) {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      const el = typeof elOrGetter === 'function' ? elOrGetter() : elOrGetter;
      el?.scrollIntoView(options);
    });
  });
}
